import { createSlice } from '@reduxjs/toolkit';

const chatbotSlice = createSlice({
    name: 'chatbot',
    initialState: {
        aiFilters: [],
        // Full structured result from the Cortex agent (new schema)
        agentFlowData: null,
    },
    reducers: {
        setAIFlowData: (state, action) => {
            state.aiFilters = action.payload.filters;
        },
        clearAIFlowData: (state) => {
            state.aiFilters = [];
        },
        setAgentFlowData: (state, action) => {
            state.agentFlowData = action.payload;
        },
        clearAgentFlowData: (state) => {
            state.agentFlowData = null;
        },
    },
});

export const { setAIFlowData, clearAIFlowData, setAgentFlowData, clearAgentFlowData } = chatbotSlice.actions;
export const selectAIFilters = (state) => state.chatbot.aiFilters;
export const selectAgentFlowData = (state) => state.chatbot.agentFlowData;
export default chatbotSlice.reducer;
